import { defineComponent as w, computed as g, createElementBlock as a, openBlock as n, createElementVNode as o, withDirectives as B, normalizeClass as F, createCommentVNode as s, createBlock as d, Fragment as P, createVNode as y, unref as r, normalizeStyle as h, mergeProps as $, toDisplayString as L, renderSlot as f, vShow as O } from "vue";
import { ScalarIconCaretRight as k, ScalarIconArrowUpRight as A } from "@scalar/icons";
import { GuideIcon as p } from "@scalar-org/guide-icons";
const D = { class: "sidebar-group-item" }, E = {
  key: 0,
  class: "sidebar-heading-chevron"
}, I = ["aria-controls", "aria-expanded"], N = { class: "sidebar-heading-link-title" }, T = {
  key: 2,
  class: "action-menu"
}, V = ["id"], G = /* @__PURE__ */ w({
  __name: "SidebarElement",
  props: {
    item: {},
    isActive: { type: Boolean },
    hasChildren: { type: Boolean },
    open: { type: Boolean },
    resolvePage: { type: Function }
  },
  emits: ["select", "toggleOpen"],
  setup(e, { emit: b }) {
    const i = e, c = b, v = g(() => {
      const t = i.item;
      return t.type === "Link" ? {
        href: t.link,
        rel: "noopener noreferrer",
        target: "_blank"
      } : t.type === "Page" ? {
        href: i.resolvePage?.(t.uid) || "#"
      } : {};
    }), m = g(() => i.hasChildren || i.item.type === "Folder");
    function C() {
      if (i.item.type !== "Link") {
        if (i.item.type === "Folder") {
          c("toggleOpen");
          return;
        }
        c("select");
      }
    }
    function S() {
      i.item.type !== "Folder" && c("toggleOpen");
    }
    return (t, l) => (n(), a("li", D, [
      o("div", {
        class: F(["sidebar-heading", {
          active_page: e.isActive,
          "sidebar-group-item__folder": e.item.type === "Folder"
          /* Folder */
        }]),
        onClick: C
      }, [
        m.value ? (n(), a("p", E, [
          o("button", {
            "aria-controls": `${e.item.uid}-content`,
            "aria-expanded": e.open,
            class: "toggle-nested-icon",
            type: "button",
            onClick: S
          }, [
            l[1] || (l[1] = o("span", { class: "sr-only" }, "Toggle group", -1)),
            e.item?.icon?.src ? (n(), a(P, { key: 0 }, [
              y(r(p), {
                class: "sidebar-icon",
                src: e.item.icon.src
              }, null, 8, ["src"]),
              y(r(k), {
                class: "sidebar-icon-caret hidden",
                style: h({
                  transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
                }),
                weight: "bold"
              }, null, 8, ["style"])
            ], 64)) : (n(), d(r(k), {
              key: 1,
              style: h({
                transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
              }),
              weight: "bold"
            }, null, 8, ["style"]))
          ], 8, I)
        ])) : s("", !0),
        o("a", $({ class: "sidebar-heading-link flex-1" }, v.value, {
          onClick: l[0] || (l[0] = (u) => e.item.type === "Link" ? u.stopPropagation() : u.preventDefault())
        }), [
          e.item?.icon?.src && !m.value ? (n(), d(r(p), {
            key: 0,
            class: "sidebar-icon",
            src: e.item.icon.src
          }, null, 8, ["src"])) : s("", !0),
          o("p", N, L(e.item.sidebarTitle?.trim() || e.item.title.trim() || e.item.type), 1)
        ], 16),
        e.item?.type === "Link" ? (n(), d(r(A), {
          key: 1,
          class: "link-icon",
          weight: "bold"
        })) : s("", !0),
        t.$slots["action-menu"] ? (n(), a("div", T, [
          f(t.$slots, "action-menu", {}, void 0, !0)
        ])) : s("", !0)
      ], 2),
      B(o("div", {
        id: `${e.item.uid}-content`,
        class: "contents"
      }, [
        f(t.$slots, "default", {}, void 0, !0)
      ], 8, V), [
        [O, e.open]
      ])
    ]));
  }
});
export {
  G as default
};
